export const AnalyticsEvents = {
  // Auth - Login
  LOGIN_STARTED: "Login Started",
  LOGIN_COMPLETED: "Login Completed",
  LOGIN_FAILED: "Login Failed",

  // Auth - Signup
  SIGNUP_STARTED: "Signup Started",
  SIGNUP_COMPLETED: "Signup Completed",
  SIGNUP_INTRO_SUBMITTED: "Signup Intro Submitted",

  // Auth - Initial Login (signup flow)
  INITIAL_LOGIN_WITH_EMAIL_STARTED: "Initial Login With Email Started",
  INITIAL_LOGIN_COMPLETED: "Initial Login Completed",
  INITIAL_LOGIN_FAILED: "Initial Login Failed",

  // Auth - Logout
  LOGOUT_COMPLETED: "Logout Completed",

  // Auth - Password
  PASSWORD_RESET_STARTED: "Password Reset Started",
  PASSWORD_RESET_EMAIL_SENT: "Password Reset Email Sent",
  PASSWORD_RESET_EMAIL_COOLDOWN: "Password Reset Email Cooldown",
  PASSWORD_RESET_EMAIL_FAILED: "Password Reset Email Failed",
  PASSWORD_RESET_COMPLETED: "Password Reset Completed",
  PASSWORD_RESET_FAILED: "Password Reset Failed",
  PASSWORD_CHANGED: "Password Changed",
  PROFILE_UPDATED: "Profile Updated",

  // Farm
  FARM_ADD_STARTED: "Farm Add Started",
  FARM_CREATED: "Farm Created",
  FARM_ADD_FAILED: "Farm Add Failed",
  FARM_UPDATED: "Farm Updated",
  FARM_DELETED: "Farm Deleted",
  FARM_SWITCHED: "Farm Switched",

  // Field
  FIELD_ADD_STARTED: "Field Add Started",
  FIELD_CREATED: "Field Created",
  FIELD_UPDATE_STARTED: "Field Update Started",
  FIELD_UPDATED: "Field Updated",
  FIELD_UPDATE_FAILED: "Field Update Failed",
  FIELD_DELETED: "Field Deleted",
  FIELD_ASSIGNED: "Field Assigned",
  FIELD_ASSIGN_FAILED: "Field Assign Failed",
  FIELD_GRASS_TYPE_UPDATED: "Field Grass Type Updated",
  FIELD_ARABLE_TYPE_UPDATED: "Field Arable Type Updated",
  ADD_MORE_FIELDS_CLICKED: "Add More Fields Clicked",

  // Animal Group
  ANIMAL_GROUP_ADD_STARTED: "Animal Group Add Started",
  ANIMAL_GROUP_CREATED: "Animal Group Created",
  ANIMAL_GROUP_UPDATED: "Animal Group Updated",
  ANIMAL_GROUP_DELETED: "Animal Group Deleted",
  ANIMAL_GROUP_VIEWED: "Animal Group Viewed",
  ANIMAL_GROUP_ADD_CLICKED: "Animal Group Add Clicked",
  ANIMAL_GROUP_FIELD_SET: "Animal Group Field Set",
  ANIMAL_GROUP_ASSIGN_FIELDS_CLICKED: "Animal Group Assign Fields Clicked",
  ANIMAL_GROUP_FIELD_ASSIGNED: "Animal Group Field Assigned",

  // Animal Move
  ANIMAL_MOVE_STARTED: "Animal Move Started",
  ANIMAL_MOVE_COMPLETED: "Animal Move Completed",
  ANIMAL_MOVE_FAILED: "Animal Move Failed",
  ANIMAL_MOVE_DRAG_COMPLETED: "Animal Move Drag Completed",

  // Cover
  BULK_COVER_INPUT_OPENED: "Bulk Cover Input Opened",
  BULK_COVER_CREATED: "Bulk Cover Created",
  // Grass Wedge
  GRASS_WEDGE_VIEWED: "Grass Wedge Viewed",
  GRASS_WEDGE_UPDATED: "Grass Wedge Updated",

  // Grazing Events
  GRAZING_EVENT_CREATED: "Grazing Event Created",
  GRAZING_EVENT_UPDATED: "Grazing Event Updated",
  GRAZING_EVENT_DELETED: "Grazing Event Deleted",
  AUTODETECTED_EVENT_ACCEPTED: "Autodetected Event Accepted",
  AUTODETECTED_EVENT_REJECTED: "Autodetected Event Rejected",

  // Yield Events
  YIELD_EVENT_CREATED: "Yield Event Created",
  YIELD_EVENT_CREATE_CANCELLED: "Yield Event Create Cancelled",
  YIELD_EVENT_UPDATED: "Yield Event Updated",
  YIELD_EVENT_UPDATE_CANCELLED: "Yield Event Update Cancelled",
  YIELD_EVENT_VIEWED: "Yield Event Viewed",

  // Feed Events
  FEED_EVENT_CREATED: "Feed Event Created",
  FEED_EVENT_CREATE_CANCELLED: "Feed Event Create Cancelled",
  FEED_EVENT_UPDATED: "Feed Event Updated",
  FEED_EVENT_UPDATE_CANCELLED: "Feed Event Update Cancelled",
  FEED_EVENT_VIEWED: "Feed Event Viewed",

  // Feed Purchase Events
  FEED_PURCHASE_CREATED: "Feed Purchase Created",
  FEED_PURCHASE_CREATE_CANCELLED: "Feed Purchase Create Cancelled",
  FEED_PURCHASE_UPDATED: "Feed Purchase Updated",
  FEED_PURCHASE_UPDATE_CANCELLED: "Feed Purchase Update Cancelled",
  FEED_PURCHASE_VIEWED: "Feed Purchase Viewed",

  // Fertilizer Events
  FERTILIZER_EVENT_CREATED: "Fertilizer Event Created",
  FERTILIZER_EVENT_CREATE_CANCELLED: "Fertilizer Event Create Cancelled",
  FERTILIZER_EVENT_UPDATED: "Fertilizer Event Updated",
  FERTILIZER_EVENT_UPDATE_CANCELLED: "Fertilizer Event Update Cancelled",
  FERTILIZER_EVENT_VIEWED: "Fertilizer Event Viewed",

  // Field Preparation Events
  FIELD_PREPARATION_CREATED: "Field Preparation Created",
  FIELD_PREPARATION_CREATE_CANCELLED: "Field Preparation Create Cancelled",
  FIELD_PREPARATION_UPDATED: "Field Preparation Updated",
  FIELD_PREPARATION_UPDATE_CANCELLED: "Field Preparation Update Cancelled",
  FIELD_PREPARATION_VIEWED: "Field Preparation Viewed",

  // Other Events (reuses the field preparation event type under the hood)
  OTHER_EVENT_CREATED: "Other Event Created",
  OTHER_EVENT_CREATE_CANCELLED: "Other Event Create Cancelled",
  OTHER_EVENT_UPDATED: "Other Event Updated",
  OTHER_EVENT_UPDATE_CANCELLED: "Other Event Update Cancelled",

  // Reseed Events
  BULK_RESEED_FORM_OPENED: "Bulk Reseed Form Opened",
  RESEED_EVENT_CREATED: "Reseed Event Created",
  RESEED_EVENT_CREATE_CANCELLED: "Reseed Event Create Cancelled",
  RESEED_EVENT_UPDATED: "Reseed Event Updated",
  RESEED_EVENT_UPDATE_CANCELLED: "Reseed Event Update Cancelled",
  RESEED_EVENT_VIEWED: "Reseed Event Viewed",

  // Feed Budget
  FEED_BUDGET_OPENED: "Feed Budget Opened",
  FEED_BUDGET_UPDATED: "Feed Budget Updated",
  FEED_BUDGET_SAVED: "Feed Budget Saved",
  FEED_BUDGET_STOCK_CLASS_EXPANDED: "Feed Budget Stock Class Expanded",
  FEED_BUDGET_GRAPH_DRAG: "Feed Budget Graph Drag",
  FEED_BUDGET_GRAPH_CREATE: "Feed Budget Graph Create",
  FEED_BUDGET_GRAPH_REMOVE: "Feed Budget Graph Remove",
  FEED_BUDGET_GRAPH_ZOOM_IN: "Feed Budget Graph Zoom In",
  FEED_BUDGET_GRAPH_ZOOM_OUT: "Feed Budget Graph Zoom Out",
  FEED_BUDGET_FIELD_LIST_INTERACTED: "Feed Budget Field List Interacted",
  FEED_BUDGET_FIELD_LIST_SAVED: "Feed Budget Field List Saved",
  FEED_BUDGET_INFO_VIEWED: "Feed Budget Info Viewed",
  FEED_BUDGET_CHANGE_ALLOCATION_CLICKED:
    "Feed Budget Change Allocation Clicked",
  FEED_BUDGET_VIEW_OPENED: "Feed Budget View Opened",

  // Diary Entry
  DIARY_ENTRY_OPENED: "Diary Entry Opened",
  DIARY_ENTRY_CREATED: "Diary Entry Created",
  DIARY_ENTRY_CANCEL_CLICKED: "Diary Entry Cancel Clicked",
  DIARY_ENTRY_DELETE_CLICKED: "Diary Entry Delete Clicked",
  DIARY_ENTRY_DELETED: "Diary Entry Deleted",

  // Files
  FILE_ADD_STARTED: "File Add Started",
  FILE_ADD_CANCELLED: "File Add Cancelled",
  FILE_UPLOADED: "File Uploaded",
  FILE_UPDATED: "File Updated",
  FILE_UPDATE_CANCELLED: "File Update Cancelled",
  FILE_DOWNLOADED: "File Downloaded",
  FILE_DOWNLOAD_MENU_CLICKED: "File Download Menu Clicked",
  FILE_VIEWED: "File Viewed",
  FILE_DELETED: "File Deleted",
  FILE_TAB_CHANGED: "File Tab Changed",

  // Navigation
  FARM_VIEW_OPENED: "Farm View Opened",
  PLANNER_OPENED: "Planner Opened",
  RECORDS_OPENED: "Records Opened",
  FARM_INSIGHTS_OPENED: "Farm Insights Opened",
  ACCESSIBLE_FARMS_INSIGHTS_OPENED: "Accessible Farms Insights Opened",
  PROJECT_INSIGHTS_OPENED: "Project Insights Opened",
  FILE_MANAGEMENT_OPENED: "File Management Opened",
  PROFILE_OPENED: "Profile Opened",
  ADD_BUTTON_CLICKED: "Add Button Clicked",

  // Programmes
  PROGRAMME_VIEWED: "Programme Viewed",
  PROGRAMME_FROM_PLANNER_VIEWED: "Programme From Planner Viewed",
  PROGRAMME_DETAIL_VIEWED: "Programme Detail Viewed",
  // Questionnaires
  QUESTIONNAIRE_STARTED: "Questionnaire Started",
  QUESTIONNAIRE_SUBMITTED: "Questionnaire Submitted",

  // Action Plan
  ACTION_DETAIL_VIEWED: "Action Detail Viewed",

  // Action Catalog (browse-actions dialog)
  ACTION_CATALOG_OPENED: "Action Catalog Opened",
  ACTION_CATALOG_CLOSED: "Action Catalog Closed",
  CATALOG_ACTION_VIEWED: "Catalog Action Viewed",
  ACTION_ADDED: "Action Added",
  ACTION_REMOVED: "Action Removed",
  ACTION_CATALOG_FILTERED: "Action Catalog Filtered",
  ACTION_CATALOG_SEARCHED: "Action Catalog Searched",
  ACTION_CATALOG_FILTERS_CLEARED: "Action Catalog Filters Cleared",
  GRANT_LINK_CLICKED: "Grant Link Clicked",

  // Evidence
  EVIDENCE_EVENT_SHARED: "Evidence Event Shared",
  EVIDENCE_EVENT_UNSHARED: "Evidence Event Unshared",
  EVIDENCE_FILE_SHARED: "Evidence File Shared",
  EVIDENCE_FILE_UNSHARED: "Evidence File Unshared",
  EVIDENCE_FILE_UPLOADED: "Evidence File Uploaded",
  EVIDENCE_FILE_PREVIEWED: "Evidence File Previewed",
  EVIDENCE_FILE_DOWNLOADED: "Evidence File Downloaded",
  EVIDENCE_DIRECT_UPLOAD_DELETED: "Evidence Direct Upload Deleted",

  // Notifications/Modals
  PUSH_NOTIFICATION_DISMISSED: "Push Notification Dismissed",

  // After Field Created Dialog
  AFTER_FIRST_FIELD_DIALOG_OPENED: "After First Field Dialog Opened",
  AFTER_NTH_FIELD_DIALOG_OPENED: "After Nth Field Dialog Opened",
  AFTER_FIRST_FIELD_DIALOG_CLOSED: "After First Field Dialog Closed",

  // Cover Reading (consolidated)
  COVER_READING_SUBMITTED: "Cover Reading Submitted",
  COVER_READING_CANCELLED: "Cover Reading Cancelled",

  // Card Clicks
  FIELD_TYPE_CARD_CLICKED: "Field Type Card Clicked",

  // Records
  RECORDS_EXPORTED: "Records Exported",
  RECORDS_FILTER_CHANGED: "Records Filter Changed",

  // Onboarding
  ONBOARDING_STEP_CLICKED: "Onboarding Step Clicked",
  ONBOARDING_VIDEO_PLAYED: "Onboarding Video Played",
  ONBOARDING_DISMISSED: "Onboarding Dismissed",
  ONBOARDING_COMPLETED: "Onboarding Completed",

  // SBI Import
  SBI_IMPORT_STARTED: "SBI Import Started",
  SBI_IMPORT_COMPLETED: "SBI Import Completed",
  SBI_IMPORT_FAILED: "SBI Import Failed",

  // Profile
  INTEGRATION_REMOVED: "Integration Removed",

  // Insights
  INSIGHT_CARD_CLICKED: "Insight Card Clicked",
  INSIGHT_DETAIL_OPENED: "Insight Detail Opened",
  INSIGHT_CTA_CLICKED: "Insight CTA Clicked",

  // Reports
  REPORT_PREVIEWED: "Report Previewed",
  REPORT_DOWNLOADED: "Report Downloaded",

  // Feed Planning
  FEED_CTA_CLICKED: "Feed CTA Clicked",

  // Session
  SESSION_STARTED: "Session Started",

  // Field - View
  FIELD_SELECTED_FROM_LIST: "Field Selected From List",
  FIELD_VIEWED: "Field Viewed",

  // Map
  MAP_FIELD_TAPPED: "Map Field Tapped",

  // Errors
  ERROR_DISPLAYED: "Error Displayed",
} as const;

export type AnalyticsEvent =
  typeof AnalyticsEvents[keyof typeof AnalyticsEvents];
